import * as React from "react";

interface Props {
  country: string;
  selectedOption: string;
}

const LegalDisclaimerTexts: React.FC<Props> = (props) => {
  const { country, selectedOption } = props;

  return (
    <>
      {country === "Germany" && selectedOption && (
        <div>
          <strong>
            These lists of beneficial owners, German Tax Voucher and Reporting
            Standing Instruction InvStG, complements our Customer Declaration
            for issuing German Tax Voucher which otherwise remains valid and
            correct.
            <br />
            <br />
            From 2012, a tax voucher is required for a tax reclaim with the
            Federal Central Tax Office (BZSt). Each end-investor eligible for
            the benefits of a Double Taxation Treaty (DTT) needs a German single
            tax voucher "Official template III" (physical paper) when reclaiming
            taxes on income from German securities.
            <br />
            <br />
            German Tax Voucher requests for corporate / institutional investors
            (including indication whether the dividend payment has derived from
            shares purchased cum-dividend, but delivered ex-dividend) for
            payments before 2012 must be delivered separately.
            <br />
            <br />
          </strong>
          <p style={{ color: "#00A5C0" }}>Legal Disclaimer</p>
          By using this Clearstream on-line website service, you agree to the
          following:
          <br />
          Except in case of willful misconduct or gross negligence, in no event
          will Clearstream, nor any of its subsidiaries, affiliates, officers,
          directors, employees or other representatives of any of them, be
          liable for any damages of any kind, including without limitation
          direct or indirect, special, incidental, or consequential damages,
          losses or expenses arising out of or in connection with the use of
          this online web site service or inability to use, or in connection
          with any failure of performance, error, omission, interruption,
          defect, mistake, delay in operation or transmission, computer virus or
          line or system failure, even if Clearstream, its subsidiaries,
          affiliates, officers, directors, employees or other representatives
          thereof, are advised of the possibility of such damages, losses or
          expenses. You agree to indemnify and hold Clearstream and its
          subsidiaries, affiliates, shareholders, officers, directors, agents,
          licensors, suppliers, alliance members, other partners, employees and
          representatives harmless from any claim or demand, including
          reasonable attorneys' fees, made by any third party due to or arising
          out of your use of or connection to this online web site service. You
          consent to the collection, storage and processing by Clearstream of
          the data provided by you while using this online web site service, in
          order to benefit you, as a customer of Clearstream, with the online
          automated form-generation utilities to fulfill the tax voucher
          requirements, available on this web site, as amended from time to
          time. The collection of the data takes place at your initiation. This
          data remains under your control at all time and can be viewed,
          modified or deleted at any time by you. Personal data are collected,
          processed and used by Clearstream in accordance with both the
          Luxembourg and German Data Protection Acts. It is your responsibility,
          by accessing, using or providing personal information to this site, to
          comply with all applicable laws and regulations and you accept to bear
          all consequences resulting from non- compliance with these
          requirements. Except as otherwise explicitly provided in these terms
          and conditions, Clearstream's web site (www.clearstream.com) terms of
          use and privacy disclaimer, as well as Clearstream's General Terms and
          Conditions and the relevant Governing Documents apply to this online
          website service. Clearstream may amend these terms and conditions at
          any time by posting the amended terms and conditions on this web site.
          <br />
          <br />
          Clearstream refers to (i) Clearstream Banking S.A. registered office
          at 42, avenue John F. Kennedy, L-1855 Luxembourg and registered with
          the Luxembourg Trade and Companies Register under number B-9248 and
          (ii) Clearstream Europe AG with registered office at 61,
          Mergenthalerallee, 65760 Eschborn, Germany and registered in Register
          B of the Amtsgericht Frankfurt am Main, Germany under number HRB 7500.
        </div>
      )}
      {country === "Italy" && (
        <div>
          <strong>
            This List of Beneficial Owners complements our One-time Certificate
            for Italian Equities for securities held with Clearstream, which in
            all respects remains valid and correct.
            <br />
            <br />
            We hereby acknowledge that, in the event that the effective amount
            of the Italian equities to which this certificate relates held in
            the relevant CB customer account is different from the total amount
            of such same Italian equities as per this declaration, all dividends
            paid on the given payment date on the Italian equities to which this
            certificate relates will be subject to a dividend withholding tax at
            the full rate. Should the instruction via this certificate be
            received by Clearstream after prescribed deadline, the total
            position of the given payment date related to this certificate will
            be subject in the same manner to a dividend withholding tax at the
            full rate.
            <br />
            <br />
            We also acknowledge that, if we are unable to disclose the identity
            of all beneficial owners, our details as account holder will be
            communicated for the undisclosed positions.
          </strong>
          <p style={{ color: "#00A5C0" }}>Legal Disclaimer</p>
          By using this Clearstream on-line website service, you agree to the
          following:
          <br />
          Except in case of willful misconduct or gross negligence, in no event
          will Clearstream, nor any of its subsidiaries, affiliates, officers,
          directors, employees or other representatives of any of them, be
          liable for any damages of any kind, including without limitation
          direct or indirect, special, incidental, or consequential damages,
          losses or expenses arising out of or in connection with the use of
          this online web site service or inability to use, or in connection
          with any failure of performance, error, omission, interruption,
          defect, mistake, delay in operation or transmission, computer virus or
          line or system failure, even if Clearstream, its subsidiaries,
          affiliates, officers, directors, employees or other representatives
          thereof, are advised of the possibility of such damages, losses or
          expenses. You agree to indemnify and hold Clearstream and its
          subsidiaries, affiliates, shareholders, officers, directors, agents,
          licensors, suppliers, alliance members, other partners, employees and
          representatives harmless from any claim or demand, including
          reasonable attorneys' fees, made by any third party due to or arising
          out of your use of or connection to this online web site service. You
          consent to the collection, storage and processing by Clearstream of
          the data provided by you while using this online web site service, in
          order to benefit you, as a customer of Clearstream, with the online
          automated form-generation utilities to fulfill the tax certification
          requirements, available on this web site, as amended from time to
          time. The collection of the data takes place at your initiation. This
          data remains under your control at all time and can be viewed,
          modified or deleted at any time by you. Personal data are collected,
          processed and used by Clearstream in accordance with both the
          Luxembourg and German Data Protection Acts. It is your responsibility,
          by accessing, using or providing personal information to this site, to
          comply with all applicable laws and regulations and you accept to bear
          all consequences resulting from non- compliance with these
          requirements. Except as otherwise explicitly provided in these terms
          and conditions, Clearstream's web site (www.clearstream.com) terms of
          use and privacy disclaimer, as well as Clearstream's General Terms and
          Conditions and the relevant Governing Documents apply to this online
          website service. Clearstream may amend these terms and conditions at
          any time by posting the amended terms and conditions on this web site.
          <br />
          <br />
          Clearstream refers to (i) Clearstream Banking S.A. registered office
          at 42, avenue John F. Kennedy, L-1855 Luxembourg and registered with
          the Luxembourg Trade and Companies Register under number B-9248 and
          (ii) Clearstream Europe AG with registered office at 61,
          Mergenthalerallee, 65760 Eschborn, Germany and registered in Register
          B of the Amtsgericht Frankfurt am Main, Germany under number HRB 7500.
        </div>
      )}
      {country === "Japan" && (
        <div>
          <strong>
            This list of beneficial owners complements our 'One-Time Certificate
            for Japanese Equities', or 'Request to Clearstream to Obtain Treaty
            Relief on Japanese Dirty Convertible Bonds', or our 'Request for
            Reclaim of Withholding Tax on Japanese Securities' (as applicable)
            which otherwise remains valid and correct.
          </strong>
          <p style={{ color: "#00A5C0" }}>Legal Disclaimer</p>
          By using this Clearstream on-line website service, you agree to the
          following:
          <br />
          Except in case of willful misconduct or gross negligence, in no event
          will Clearstream, nor any of its subsidiaries, affiliates, officers,
          directors, employees or other representatives of any of them, be
          liable for any damages of any kind, including without limitation
          direct or indirect, special, incidental, or consequential damages,
          losses or expenses arising out of or in connection with the use of
          this online web site service or inability to use, or in connection
          with any failure of performance, error, omission, interruption,
          defect, mistake, delay in operation or transmission, computer virus or
          line or system failure, even if Clearstream, its subsidiaries,
          affiliates, officers, directors, employees or other representatives
          thereof, are advised of the possibility of such damages, losses or
          expenses. You agree to indemnify and hold Clearstream and its
          subsidiaries, affiliates, shareholders, officers, directors, agents,
          licensors, suppliers, alliance members, other partners, employees and
          representatives harmless from any claim or demand, including
          reasonable attorneys' fees, made by any third party due to or arising
          out of your use of or connection to this online web site service. You
          consent to the collection, storage and processing by Clearstream of
          the data provided by you while using this online web site service, in
          order to benefit you, as a customer of Clearstream, with the online
          automated form-generation utilities to fulfill the tax certification
          requirements, available on this web site, as amended from time to
          time. The collection of the data takes place at your initiation. This
          data remains under your control at all time and can be viewed,
          modified or deleted at any time by you. Personal data are collected,
          processed and used by Clearstream in accordance with both the
          Luxembourg and German Data Protection Acts. It is your responsibility,
          by accessing, using or providing personal information to this site, to
          comply with all applicable laws and regulations and you accept to bear
          all consequences resulting from non- compliance with these
          requirements. Except as otherwise explicitly provided in these terms
          and conditions, Clearstream's web site (www.clearstream.com) terms of
          use and privacy disclaimer, as well as Clearstream's General Terms and
          Conditions and the relevant Governing Documents apply to this online
          website service. Clearstream may amend these terms and conditions at
          any time by posting the amended terms and conditions on this web site.
          <br />
          <br />
          Clearstream refers to (i) Clearstream Banking S.A. registered office
          at 42, avenue John F. Kennedy, L-1855 Luxembourg and registered with
          the Luxembourg Trade and Companies Register under number B-9248 and
          (ii) Clearstream Europe AG with registered office at 61,
          Mergenthalerallee, 65760 Eschborn, Germany and registered in Register
          B of the Amtsgericht Frankfurt am Main, Germany under number HRB 7500.
        </div>
      )}
      {country === "South Korea" && (
        <div>
          <strong>
            This list of beneficial owners complements the instruction that we
            have already sent to Clearstream via an authenticated means of
            communication.
          </strong>
          <p style={{ color: "#00A5C0" }}>Legal Disclaimer</p>
          By using this Clearstream on-line website service, you agree to the
          following:
          <br />
          Except in case of willful misconduct or gross negligence, in no event
          will Clearstream, nor any of its subsidiaries, affiliates, officers,
          directors, employees or other representatives of any of them, be
          liable for any damages of any kind, including without limitation
          direct or indirect, special, incidental, or consequential damages,
          losses or expenses arising out of or in connection with the use of
          this online web site service or inability to use, or in connection
          with any failure of performance, error, omission, interruption,
          defect, mistake, delay in operation or transmission, computer virus or
          line or system failure, even if Clearstream, its subsidiaries,
          affiliates, officers, directors, employees or other representatives
          thereof, are advised of the possibility of such damages, losses or
          expenses. You agree to indemnify and hold Clearstream and its
          subsidiaries, affiliates, shareholders, officers, directors, agents,
          licensors, suppliers, alliance members, other partners, employees and
          representatives harmless from any claim or demand, including
          reasonable attorneys' fees, made by any third party due to or arising
          out of your use of or connection to this online web site service. You
          consent to the collection, storage and processing by Clearstream of
          the data provided by you while using this online web site service, in
          order to benefit you, as a customer of Clearstream, with the online
          automated form-generation utilities to fulfill the tax certification
          requirements, available on this web site, as amended from time to
          time. The collection of the data takes place at your initiation. This
          data remains under your control at all time and can be viewed,
          modified or deleted at any time by you. Personal data are collected,
          processed and used by Clearstream in accordance with both the
          Luxembourg and German Data Protection Acts. It is your responsibility,
          by accessing, using or providing personal information to this site, to
          comply with all applicable laws and regulations and you accept to bear
          all consequences resulting from non- compliance with these
          requirements. Except as otherwise explicitly provided in these terms
          and conditions, Clearstream's web site (www.clearstream.com) terms of
          use and privacy disclaimer, as well as Clearstream's General Terms and
          Conditions and the relevant Governing Documents apply to this online
          website service. Clearstream may amend these terms and conditions at
          any time by posting the amended terms and conditions on this web site.
          <br />
          <br />
          Clearstream refers to (i) Clearstream Banking S.A. registered office
          at 42, avenue John F. Kennedy, L-1855 Luxembourg and registered with
          the Luxembourg Trade and Companies Register under number B-9248 and
          (ii) Clearstream Europe AG with registered office at 61,
          Mergenthalerallee, 65760 Eschborn, Germany and registered in Register
          B of the Amtsgericht Frankfurt am Main, Germany under number HRB 7500.
        </div>
      )}
      {country === "Spain" && (
        <div>
          <strong>
            We assume full responsibility for the accuracy, completeness and
            validity of the information contained in this Breakdown and will
            hold Clearstream harmless for any claim or liability in relation to
            the content of this Breakdown. We understand and agree that
            providing this Breakdown does not guarantee a tax refund. This
            Breakdown is governed and construed in accordance with the laws of
            the Grand Duchy of Luxembourg and the courts of Luxembourg shall
            have exclusive jurisdiction for all legal proceedings relating
            hereto. We hereby request Clearstream Europe to forward our standard
            refund application to the Spanish Tax Authorities or to the Spanish
            issuer for the refund amounts specified above. Please credit the
            withholding tax refunded to mentioned Clearstream account(s), upon
            receipt from the Spanish Tax Authorities. We hereby acknowledge and
            agree that in case the withholding tax is refunded by the Spanish
            Tax Authorities directly on the cash account of the beneficial
            owner, we undertake to inform Clearstream immediately after receipt
            of the funds by the beneficial owner. Additionally, we acknowledge
            that Clearstream reserves the right to stop the service if we fail
            to comply with this undertaking in a repeating manner. We hereby
            acknowledge and agree that neither Clearstream nor the agent
            guarantee the acceptance of the reclaim or payment of the refund by
            the relevant tax authorities; and We hereby acknowledge and agree
            that Clearstream shall not at any time be held liable for any loss
            or damage caused by the tax reclaim procedure and shall be held
            harmless in respect of any liability arising from any action taken
            in relation to the tax reclaim procedure.
          </strong>
          <br /> <br />
          <p style={{ color: "#00A5C0" }}>Legal Disclaimer</p>
          By using this Clearstream on-line website service, you agree to the
          following:
          <br />
          Except in case of willful misconduct or gross negligence, in no event
          will Clearstream, nor any of its subsidiaries, affiliates, officers,
          directors, employees or other representatives of any of them, be
          liable for any damages of any kind, including without limitation
          direct or indirect, special, incidental, or consequential damages,
          losses or expenses arising out of or in connection with the use of
          this online web site service or inability to use, or in connection
          with any failure of performance, error, omission, interruption,
          defect, mistake, delay in operation or transmission, computer virus or
          line or system failure, even if Clearstream, its subsidiaries,
          affiliates, officers, directors, employees or other representatives
          thereof, are advised of the possibility of such damages, losses or
          expenses. You agree to indemnify and hold Clearstream and its
          subsidiaries, affiliates, shareholders, officers, directors, agents,
          licensors, suppliers, alliance members, other partners, employees and
          representatives harmless from any claim or demand, including
          reasonable attorneys' fees, made by any third party due to or arising
          out of your use of or connection to this online web site service. You
          consent to the collection, storage and processing by Clearstream of
          the data provided by you while using this online web site service, in
          order to benefit you, as a customer of Clearstream, with the online
          automated form-generation utilities to fulfill the tax certification
          requirements, available on this web site, as amended from time to
          time. The collection of the data takes place at your initiation. This
          data remains under your control at all time and can be viewed,
          modified or deleted at any time by you. Personal data are collected,
          processed and used by Clearstream in accordance with both the
          Luxembourg and German Data Protection Acts. It is your responsibility,
          by accessing, using or providing personal information to this site, to
          comply with all applicable laws and regulations and you accept to bear
          all consequences resulting from non- compliance with these
          requirements. Except as otherwise explicitly provided in these terms
          and conditions, Clearstream's web site (www.clearstream.com) terms of
          use and privacy disclaimer, as well as Clearstream's General Terms and
          Conditions and the relevant Governing Documents apply to this online
          website service. Clearstream may amend these terms and conditions at
          any time by posting the amended terms and conditions on this web site.
          <br />
          <br />
          Clearstream refers to (i) Clearstream Banking S.A. registered office
          at 42, avenue John F. Kennedy, L-1855 Luxembourg and registered with
          the Luxembourg Trade and Companies Register under number B-9248 and
          (ii) Clearstream Europe AG with registered office at 61,
          Mergenthalerallee, 65760 Eschborn, Germany and registered in Register
          B of the Amtsgericht Frankfurt am Main, Germany under number HRB 7500.
        </div>
      )}
      {country === "Singapore" && (
        <div>
          <strong>
            This list of beneficial owners complements our 'Letter of Request to
            Clearstream for reclaim of withholding tax on Singaporean Securities
            ' which otherwise remains valid and correct.
          </strong>
          <p style={{ color: "#00A5C0" }}>Legal Disclaimer</p>
          By using this Clearstream on-line website service, you agree to the
          following:
          <br />
          Except in case of willful misconduct or gross negligence, in no event
          will Clearstream, nor any of its subsidiaries, affiliates, officers,
          directors, employees or other representatives of any of them, be
          liable for any damages of any kind, including without limitation
          direct or indirect, special, incidental, or consequential damages,
          losses or expenses arising out of or in connection with the use of
          this online web site service or inability to use, or in connection
          with any failure of performance, error, omission, interruption,
          defect, mistake, delay in operation or transmission, computer virus or
          line or system failure, even if Clearstream, its subsidiaries,
          affiliates, officers, directors, employees or other representatives
          thereof, are advised of the possibility of such damages, losses or
          expenses. You agree to indemnify and hold Clearstream and its
          subsidiaries, affiliates, shareholders, officers, directors, agents,
          licensors, suppliers, alliance members, other partners, employees and
          representatives harmless from any claim or demand, including
          reasonable attorneys' fees, made by any third party due to or arising
          out of your use of or connection to this online web site service. You
          consent to the collection, storage and processing by Clearstream of
          the data provided by you while using this online web site service, in
          order to benefit you, as a customer of Clearstream, with the online
          automated form-generation utilities to fulfill the tax certification
          requirements, available on this web site, as amended from time to
          time. The collection of the data takes place at your initiation. This
          data remains under your control at all time and can be viewed,
          modified or deleted at any time by you. Personal data are collected,
          processed and used by Clearstream in accordance with both the
          Luxembourg and German Data Protection Acts. It is your responsibility,
          by accessing, using or providing personal information to this site, to
          comply with all applicable laws and regulations and you accept to bear
          all consequences resulting from non- compliance with these
          requirements. Except as otherwise explicitly provided in these terms
          and conditions, Clearstream's web site (www.clearstream.com) terms of
          use and privacy disclaimer, as well as Clearstream's General Terms and
          Conditions and the relevant Governing Documents apply to this online
          website service. Clearstream may amend these terms and conditions at
          any time by posting the amended terms and conditions on this web site.
          <br />
          <br />
          Clearstream refers to (i) Clearstream Banking S.A. registered office
          at 42, avenue John F. Kennedy, L-1855 Luxembourg and registered with
          the Luxembourg Trade and Companies Register under number B-9248 and
          (ii) Clearstream Europe AG with registered office at 61,
          Mergenthalerallee, 65760 Eschborn, Germany and registered in Register
          B of the Amtsgericht Frankfurt am Main, Germany under number HRB 7500.
        </div>
      )}
    </>
  );
};

export default LegalDisclaimerTexts;
